import React from 'react'

import { array, string } from 'prop-types'

import AssetItem from 'Pods/UnifiedNavigation/Shared/AssetItem/AssetItem'

function CategoryColumn({ items, columnKey }) {
  return (
    <div className="assets-3d-categories__categories-column">
      {items.map((item) => (
        <AssetItem
          key={`${columnKey}-${item.title}`}
          title={item.title}
          icon={item.slug}
          href={item.path}
          subcategories={item.subcategories}
        />
      ))}
    </div>
  )
}

CategoryColumn.propTypes = {
  items: array.isRequired,
  columnKey: string.isRequired,
}

export default CategoryColumn
